//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// InterestRateModelV2
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x76074C0b66A480F7bc6AbDaA9643a7dc99e18314)
 */
export const interestRateModelV2Abi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: '_config',
        internalType: 'struct IInterestRateModel.Config',
        type: 'tuple',
        components: [
          { name: 'uopt', internalType: 'int256', type: 'int256' },
          { name: 'ucrit', internalType: 'int256', type: 'int256' },
          { name: 'ulow', internalType: 'int256', type: 'int256' },
          { name: 'ki', internalType: 'int256', type: 'int256' },
          { name: 'kcrit', internalType: 'int256', type: 'int256' },
          { name: 'klow', internalType: 'int256', type: 'int256' },
          { name: 'klin', internalType: 'int256', type: 'int256' },
          { name: 'beta', internalType: 'int256', type: 'int256' },
          { name: 'ri', internalType: 'int256', type: 'int256' },
          { name: 'Tcrit', internalType: 'int256', type: 'int256' },
        ],
      },
      { name: '_owner', internalType: 'address', type: 'address' },
    ],
    stateMutability: 'nonpayable',
  },
  { type: 'error', inputs: [], name: 'InvalidBeta' },
  { type: 'error', inputs: [], name: 'InvalidKcrit' },
  { type: 'error', inputs: [], name: 'InvalidKi' },
  { type: 'error', inputs: [], name: 'InvalidKlin' },
  { type: 'error', inputs: [], name: 'InvalidKlow' },
  { type: 'error', inputs: [], name: 'InvalidRi' },
  { type: 'error', inputs: [], name: 'InvalidTcrit' },
  { type: 'error', inputs: [], name: 'InvalidTimestamps' },
  { type: 'error', inputs: [], name: 'InvalidUcrit' },
  { type: 'error', inputs: [], name: 'InvalidUlow' },
  { type: 'error', inputs: [], name: 'InvalidUopt' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'silo', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'config',
        internalType: 'struct IInterestRateModel.Config',
        type: 'tuple',
        components: [
          { name: 'uopt', internalType: 'int256', type: 'int256' },
          { name: 'ucrit', internalType: 'int256', type: 'int256' },
          { name: 'ulow', internalType: 'int256', type: 'int256' },
          { name: 'ki', internalType: 'int256', type: 'int256' },
          { name: 'kcrit', internalType: 'int256', type: 'int256' },
          { name: 'klow', internalType: 'int256', type: 'int256' },
          { name: 'klin', internalType: 'int256', type: 'int256' },
          { name: 'beta', internalType: 'int256', type: 'int256' },
          { name: 'ri', internalType: 'int256', type: 'int256' },
          { name: 'Tcrit', internalType: 'int256', type: 'int256' },
        ],
        indexed: false,
      },
    ],
    name: 'ConfigUpdate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newPendingOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipPending',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ASSET_DATA_OVERFLOW_LIMIT',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DP',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'RCOMP_MAX',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'X_MAX',
    outputs: [{ name: '', internalType: 'int256', type: 'int256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'acceptOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_c',
        internalType: 'struct IInterestRateModel.Config',
        type: 'tuple',
        components: [
          { name: 'uopt', internalType: 'int256', type: 'int256' },
          { name: 'ucrit', internalType: 'int256', type: 'int256' },
          { name: 'ulow', internalType: 'int256', type: 'int256' },
          { name: 'ki', internalType: 'int256', type: 'int256' },
          { name: 'kcrit', internalType: 'int256', type: 'int256' },
          { name: 'klow', internalType: 'int256', type: 'int256' },
          { name: 'klin', internalType: 'int256', type: 'int256' },
          { name: 'beta', internalType: 'int256', type: 'int256' },
          { name: 'ri', internalType: 'int256', type: 'int256' },
          { name: 'Tcrit', internalType: 'int256', type: 'int256' },
        ],
      },
      { name: '_totalDeposits', internalType: 'uint256', type: 'uint256' },
      { name: '_totalBorrowAmount', internalType: 'uint256', type: 'uint256' },
      {
        name: '_interestRateTimestamp',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: '_blockTimestamp', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'calculateCompoundInterestRate',
    outputs: [
      { name: 'rcomp', internalType: 'uint256', type: 'uint256' },
      { name: 'ri', internalType: 'int256', type: 'int256' },
      { name: 'Tcrit', internalType: 'int256', type: 'int256' },
    ],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_c',
        internalType: 'struct IInterestRateModel.Config',
        type: 'tuple',
        components: [
          { name: 'uopt', internalType: 'int256', type: 'int256' },
          { name: 'ucrit', internalType: 'int256', type: 'int256' },
          { name: 'ulow', internalType: 'int256', type: 'int256' },
          { name: 'ki', internalType: 'int256', type: 'int256' },
          { name: 'kcrit', internalType: 'int256', type: 'int256' },
          { name: 'klow', internalType: 'int256', type: 'int256' },
          { name: 'klin', internalType: 'int256', type: 'int256' },
          { name: 'beta', internalType: 'int256', type: 'int256' },
          { name: 'ri', internalType: 'int256', type: 'int256' },
          { name: 'Tcrit', internalType: 'int256', type: 'int256' },
        ],
      },
      { name: '_totalDeposits', internalType: 'uint256', type: 'uint256' },
      { name: '_totalBorrowAmount', internalType: 'uint256', type: 'uint256' },
      {
        name: '_interestRateTimestamp',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: '_blockTimestamp', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'calculateCompoundInterestRateWithOverflowDetection',
    outputs: [
      { name: 'rcomp', internalType: 'uint256', type: 'uint256' },
      { name: 'ri', internalType: 'int256', type: 'int256' },
      { name: 'Tcrit', internalType: 'int256', type: 'int256' },
      { name: 'overflow', internalType: 'bool', type: 'bool' },
    ],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_c',
        internalType: 'struct IInterestRateModel.Config',
        type: 'tuple',
        components: [
          { name: 'uopt', internalType: 'int256', type: 'int256' },
          { name: 'ucrit', internalType: 'int256', type: 'int256' },
          { name: 'ulow', internalType: 'int256', type: 'int256' },
          { name: 'ki', internalType: 'int256', type: 'int256' },
          { name: 'kcrit', internalType: 'int256', type: 'int256' },
          { name: 'klow', internalType: 'int256', type: 'int256' },
          { name: 'klin', internalType: 'int256', type: 'int256' },
          { name: 'beta', internalType: 'int256', type: 'int256' },
          { name: 'ri', internalType: 'int256', type: 'int256' },
          { name: 'Tcrit', internalType: 'int256', type: 'int256' },
        ],
      },
      { name: '_totalDeposits', internalType: 'uint256', type: 'uint256' },
      { name: '_totalBorrowAmount', internalType: 'uint256', type: 'uint256' },
      {
        name: '_interestRateTimestamp',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: '_blockTimestamp', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'calculateCurrentInterestRate',
    outputs: [{ name: 'rcur', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
    ],
    name: 'config',
    outputs: [
      { name: 'uopt', internalType: 'int256', type: 'int256' },
      { name: 'ucrit', internalType: 'int256', type: 'int256' },
      { name: 'ulow', internalType: 'int256', type: 'int256' },
      { name: 'ki', internalType: 'int256', type: 'int256' },
      { name: 'kcrit', internalType: 'int256', type: 'int256' },
      { name: 'klow', internalType: 'int256', type: 'int256' },
      { name: 'klin', internalType: 'int256', type: 'int256' },
      { name: 'beta', internalType: 'int256', type: 'int256' },
      { name: 'ri', internalType: 'int256', type: 'int256' },
      { name: 'Tcrit', internalType: 'int256', type: 'int256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'address', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_blockTimestamp', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getCompoundInterestRate',
    outputs: [{ name: 'rcomp', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_blockTimestamp', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getCompoundInterestRateAndUpdate',
    outputs: [{ name: 'rcomp', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'address', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'getConfig',
    outputs: [
      {
        name: '',
        internalType: 'struct IInterestRateModel.Config',
        type: 'tuple',
        components: [
          { name: 'uopt', internalType: 'int256', type: 'int256' },
          { name: 'ucrit', internalType: 'int256', type: 'int256' },
          { name: 'ulow', internalType: 'int256', type: 'int256' },
          { name: 'ki', internalType: 'int256', type: 'int256' },
          { name: 'kcrit', internalType: 'int256', type: 'int256' },
          { name: 'klow', internalType: 'int256', type: 'int256' },
          { name: 'klin', internalType: 'int256', type: 'int256' },
          { name: 'beta', internalType: 'int256', type: 'int256' },
          { name: 'ri', internalType: 'int256', type: 'int256' },
          { name: 'Tcrit', internalType: 'int256', type: 'int256' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'address', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_blockTimestamp', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getCurrentInterestRate',
    outputs: [{ name: 'rcur', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'interestRateModelPing',
    outputs: [{ name: '', internalType: 'bytes4', type: 'bytes4' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silos', internalType: 'address[]', type: 'address[]' },
      {
        name: '_siloRepository',
        internalType: 'contract ISiloRepository',
        type: 'address',
      },
    ],
    name: 'migrationFromV1',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'address', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_blockTimestamp', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'overflowDetected',
    outputs: [{ name: 'overflow', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'pendingOwner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'removePendingOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'address', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
      {
        name: '_config',
        internalType: 'struct IInterestRateModel.Config',
        type: 'tuple',
        components: [
          { name: 'uopt', internalType: 'int256', type: 'int256' },
          { name: 'ucrit', internalType: 'int256', type: 'int256' },
          { name: 'ulow', internalType: 'int256', type: 'int256' },
          { name: 'ki', internalType: 'int256', type: 'int256' },
          { name: 'kcrit', internalType: 'int256', type: 'int256' },
          { name: 'klow', internalType: 'int256', type: 'int256' },
          { name: 'klin', internalType: 'int256', type: 'int256' },
          { name: 'beta', internalType: 'int256', type: 'int256' },
          { name: 'ri', internalType: 'int256', type: 'int256' },
          { name: 'Tcrit', internalType: 'int256', type: 'int256' },
        ],
      },
    ],
    name: 'setConfig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newPendingOwner', internalType: 'address', type: 'address' },
    ],
    name: 'transferPendingOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x76074C0b66A480F7bc6AbDaA9643a7dc99e18314)
 */
export const interestRateModelV2Address = {
  1: '0x76074C0b66A480F7bc6AbDaA9643a7dc99e18314',
} as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x76074C0b66A480F7bc6AbDaA9643a7dc99e18314)
 */
export const interestRateModelV2Config = {
  address: interestRateModelV2Address,
  abi: interestRateModelV2Abi,
} as const
